export default __webpack_public_path__ + "static/media/saelos-negative.ba961248.svg";